<template>
    <div class="calender-warp">
        <div class="calender-top">
            <slot name="title"></slot>
            <div class="calender-month">
                <i class="el-icon-arrow-left" @click="changeMonth('up')"></i>
                <div>
                    <span class="year-warp">{{ year }}</span>
                    <span>-</span>
                    <span class="month-warp">{{ month }}</span>
                </div>
                <i class="el-icon-arrow-right" @click="changeMonth('next')"></i>
            </div>
        </div>
        <div class="calender-content">
            <div class="conetent-week">
                <div class="week-item" :style="{ width: width + 'px', height: height + 'px' }" v-for="item in week"
                    :key="item">
                    {{ item }}</div>
            </div>
            <div class="content-day">
                <div v-for="(item, index) in dayList" :key="index">
                    <div :class="item.id == currentId ? 'active day-item' : 'day-item'" v-if="item.value"
                        @click="changeDay(item.date)"
                        :style="{ width: width + 'px', height: dayHeight + 'px', color: dayColor, background: dayBackground }">
                        <div v-if="item.id == thisId" class="color1890">今</div>
                        <div v-else>{{ item.value }}</div>
                        <div :ref="'day' + item.id" class="day-label"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { CommonDTO } from '@/DTO/index'
import { Utils } from '@/utils/utils'
export default {
    // 定义引入的组件
    components: {},
    props: {
        // 标题
        titile: {
            type: String,
            default: '日历'
        },
        //周
        week: {
            type: Array,
            default: () => {
                return ['一', '二', '三', '四', '五', '六', '日'];
            }
        },
        //周的每个格子宽度
        width: {
            type: String | Number,
            default: 36
        },
        //周的每个格子高度
        height: {
            type: String | Number,
            default: 28
        },
        //天的每个格子高度
        dayHeight: {
            type: String | Number,
            default: 36
        },
        //天格子的字体颜色
        dayColor: {
            type: String,
            default: '#1F2329'
        },
        //天格子的背景颜色
        dayBackground: {
            type: String,
            default: '#fff'
        },
    },
    data() {
        return {
            year: '',//显示的年
            month: '',//显示的月
            day: '',//显示的日
            dayList: [],//日列表
            thisYear: '',//今年
            thisMonth: '',//当天的月份
            thisDay: '',//今天的号数
            activeDate: '',//激活的日期
            currentId: '',//当前日期的时间戳
            thisId: '',//今天日期的时间戳
        }
    },
    //变量监听
    watch: {
        activeDate: {
            immediate: true,
            handler() {
                this.currentId = this.$moment(this.activeDate).valueOf()
            },
        }
    },
    // 页面初始化
    created() {
        this.init();

    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 处理今天的年月日数据
         */
        async init() {
            let systemTime = CommonDTO.getSystemTimeDTO()
            let currentDate = this.$moment(systemTime).format('YYYY-MM-DD');
            this.thisYear = this.$moment(systemTime).year();
            this.thisMonth = Utils.gt(this.$moment(systemTime).month() + 1, 9) ? this.$moment(systemTime).month() + 1 : `0${this.$moment(systemTime).month() + 1}`;
            this.thisDay = Utils.gt(this.$moment(systemTime).date(), 9) ? this.$moment(systemTime).date() : `0${this.$moment(systemTime).date()}`;
            this.activeDate = `${this.thisYear}-${this.thisMonth}-${this.thisDay}`
            this.thisId = this.$moment(this.activeDate).startOf('day').valueOf();
            this.getDayList(currentDate);
            this.castCurrenDate()
        },
        /**
         * 切换月份
         * type up 上个月 next 下个月
         */
        changeMonth(type) {
            let month = this.month
            let year = this.year
            if (type == 'up') {
                if (month == 1) {
                    // 如果当前是1月，那么年份对应-1，月份为12
                    year = this.$bigNumber(year, '-', 1)
                    month = 12
                } else {
                    // 如果当前不是1月，则对应月份直接-1
                    month = this.$bigNumber(month, '-', 1)
                }
            } else if ('next') {
                if (month == 12) {
                    // 如果当前是12月，则年份对应+1，月份为1
                    year = this.$bigNumber(year, '+', 1)
                    month = 1
                } else {
                    // 如果当前不是12月，则对应月份直接+1
                    month = this.$bigNumber(month, '+', 1)
                }
            }
            month = Utils.gt(month, 9) ? month : `0${month}`
            let date = `${year}-${month}`
            this.getDayList(date)
            // this.init()
            this.$emit('changeMonth', { year: this.year, month: this.month })
        },
        /**
         * 根据年月日生成对应日历数据
         * date 日期
         */
        getDayList(date) {
            let moment = this.$moment(date);
            let year = moment.year();
            let month = Utils.gt(moment.month() + 1, 9) ? moment.month() + 1 : `0${moment.month() + 1}`
            let days = moment.daysInMonth()  //判断当月有多少天
            let dayList = []
            for (let i = 1; i <= days; i++) {
                dayList.push({
                    id: this.$moment(`${year}-${month}-${Utils.gt(i, 9) ? i : `0${i}`}`).valueOf(),
                    date: `${year}-${month}-${Utils.gt(i, 9) ? i : `0${i}`}`,
                    value: i,
                    label: ''
                })
            }
            let firstweekDay = moment.startOf('month').weekday();//判断当月的第一天是星期几
            if (firstweekDay > 1) {
                for (let index = 1; index < firstweekDay; index++) {
                    dayList.unshift({})  //添加空数据，模仿日历显示
                }
            }
            if (firstweekDay == 0) {
                for (let index = 1; index < 7; index++) {
                    dayList.unshift({})  //添加空数据，模仿日历显示
                }
            }
            this.year = year;
            this.month = month;
            this.dayList = dayList;
        },
        /**
         * 切换日期
         */
        changeDay(date) {
            this.activeDate = date
            this.castCurrenDate()
        },
        /**
         * 抛出当前的日期
         */
        castCurrenDate() {
            this.$emit('currenDate', this.activeDate)
        },
    },
}
</script>
<style lang="less" scoped src="./index.less"></style>